var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useState, useEffect, useCallback } from "react";
import { createContext, useContext } from "react";
import { getLibZL } from "./getLibZL";
export const LibZLContext = createContext(null);
export const useLibZLInstance = () => useContext(LibZLContext);
export const LibZLInstanceProvider = ({ src, integrity, origin, console, children }) => {
    const [libZL, setLibZL] = useState(null);
    const createLibZLInstance = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        const libZL = getLibZL(Object.assign(Object.assign({}, src), { integrity, origin, console }));
        const resolvedLibZL = libZL instanceof Promise ? yield libZL : libZL;
        window.libZL = resolvedLibZL;
        setLibZL(resolvedLibZL);
    }), [src, integrity, origin, console]);
    useEffect(() => {
        createLibZLInstance();
    }, [createLibZLInstance]);
    return (React.createElement(LibZLContext.Provider, { value: libZL }, children));
};
